import { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';
import { Button } from './ui/button';
import { useReserveBottomSpace } from '../hooks/useReserveBottomSpace';

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const barRef = useReserveBottomSpace();

  useEffect(() => {
    const dismissed = sessionStorage.getItem('pwa-install-dismissed');
    if (dismissed) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setShowBanner(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowBanner(false);
    sessionStorage.setItem('pwa-install-dismissed', '1');
  };

  if (!showBanner) return null;

  return (
    <div ref={barRef} className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border p-4 shadow-lg md:hidden">
      <div className="flex items-center gap-3">
        <div className="flex-1">
          <p className="text-sm font-medium">Installer InfoFlow</p>
          <p className="text-xs text-muted-foreground">Accédez rapidement depuis votre écran d'accueil</p>
        </div>
        <Button size="sm" onClick={handleInstall} className="bg-[#D62828] hover:bg-[#B91C1C]">
          <Download className="h-4 w-4 mr-1" />
          Installer
        </Button>
        <button onClick={handleDismiss} className="text-muted-foreground p-1">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
